import Vue from 'vue'
import { setInteractionMode, ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, required_if, email, regex, alpha_dash, min_value, max_value, numeric } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'The {_field_} is required'
})

extend('required_if', required_if)
extend('numeric', numeric)
extend('alpha_dash', alpha_dash)
extend('email', email)
extend('regex', regex)
extend('min_value', min_value)
extend('max_value', max_value)

extend('min', {
  validate (value, args) {
    return value.length >= args.length
  },
  params: ['length'],
  message: 'The {_field_} field must have at least {length} characters'
})

extend('max', {
  validate (value, args) {
    return value.length <= args.length
  },
  params: ['length'],
  message: 'The {_field_} field may not be greater than {length} characters'
})

extend('length', {
  validate (value, args) {
    return value.length <= args.length
  },
  params: ['length'],
  message: 'The {_field_} field can have only {length} of checked items'
})

extend('password', {
  validate (value, { target }) {
    return value === target
  },
  params: ['target'],
  message: 'Password confirmation does not match'
})

// setInteractionMode('eager');


Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
